import React, { useEffect,useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import {toast} from 'react-toastify';
import {useFormik} from 'formik';
import * as NumericInput from "react-numeric-input";
import * as Yup from 'yup';
import CustomSelect from '../../components/custom-select/CustomSelect';
import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import AlertDialog from '../../components/alert-dialog/AlertDialog';
import moment from 'moment';
import * as RestService from '../../services/eisRest';





  const ContractModal = (props) => {

   

    const [t] = useTranslation();     
    const [selectedRecord, setSelectedRecord] = useState();
    const [entityId, setEntityId] = useState(); 
    const [isOpen, setIsOpen] = useState(false);
    const [contract, setContract] = useState([]);   
    const [openAlertDialog, setOpenAlertDialog] = useState(false);
    const [name, setName] = useState();
    const [price, setPrice] = useState(0);
    const [validFromLong, setValidFromLong] = useState(new Date());
    const [validToLong, setValidToLong] = useState(new Date());
    const dialogRef = React.createRef();
  
    const pricePerOptions = [
      { value: 'once', label:  t('partner.label.once') },
      { value: 'month', label: t('partner.label.month') },            
      { value: 'year', label: t('partner.label.year') },      
    ];

    const hideModal = () => {
      setIsOpen(false);
      showChanged(false);
    };

    const showChanged = (newStatus) => {
      props.parentCallback(newStatus);
    }
    
    const deleteRecord = () => {
      setOpenAlertDialog(true);
    };

    useEffect(() => {
      formik.resetForm();
      setIsOpen(props.modal);
      showChanged(props.modal);

    }, [props.modal])

    useEffect(() => {   
      setSelectedRecord(props.selectedRecord);
      RestService.callAnyApi('partner/getPartnerContract?id='+props.selectedRecord+"&partnerId="+props.entityId, null)
      .then((data) => {
        
           setContract(data);
           setPrice(data.price);
           setValidFromLong(data.validFromLong);
           setValidToLong(data.validToLong);
      })
      .catch((error) => {
        console.log(error);
      });

    }, [props.selectedRecord])


    useEffect(() => {      
      setEntityId(props.entityId);
    }, [props.entityId])


    const getNewContractName = () => {

      RestService.callAnyApi("partner/getNewContractName", null)
      .then((data) => {
         
          formik.setFieldValue('name',data);
      })
      .catch((error) => {
        console.log(error);
      });

    }
  
    const numberFormat = (num) => {
      return  parseFloat(num.replace(",", "."));
    }

    const handleNumericChange =(k,value)=>{
     
     
      switch(k){
          case "price":
              setPrice(value);
          break;          
      }
  }

    const handleAlertDialogCallback = (clickedValue) => {
      setOpenAlertDialog(false);
      if(clickedValue==='OK'){
        RestService.callAnyApi('basic/deleteRecord?entity=partnerContract&id='+selectedRecord, null).then(
          (data) => {
            hideModal();
          })
          .catch((error) => {
            console.log(error);
          });
      }
         
    }

    
    const showError = (error,serverMessage) =>{
      if(serverMessage==null){
          toast.error(
            (error.response &&
                error.response.data &&
                error.response.data.message &&
                error.responseMessage) ||
                t('general.message.failed')
          );
        }else{
          toast.error(serverMessage);
        }
    }

    const save = (url,values) => {
         
      
      contract.name=values.name;     
      contract.price = price;
      contract.pricePer=values.pricePer;

      if(validFromLong==0){setValidFromLong(null);}
      if(validToLong==0){setValidToLong(null);}

      contract.validFromLong = validFromLong;
      contract.validToLong = validToLong;
      if(validFromLong==null){
        contract.validFrom = "";
      }else{
        contract.validFrom = moment(validFromLong).format('DD.MM.YYYY');
      }
      if(validToLong==null){
        contract.validTo = "";
      }else{
        contract.validTo = moment(validToLong).format('DD.MM.YYYY');
      }
      contract.description = values.description;

      

      RestService.callAnyApi(url, contract)
          .then((data) => {                                                 
                      if(data.responseMessage==='OK'){
                          toast.success(t('general.message.saveSucceed'));                                              
                          hideModal();
                      }else{
                          showError(null,data.responseMessage);
                      }
                  
                 
          })
          .catch((error) => {               
            showError(error,null);
          });
    };

    const formik = useFormik({
      enableReinitialize: true,
      initialValues: {    
        name: contract.name || "",
        price: contract.price || 0,
        pricePer: contract.pricePer || "once",
        description: contract.description || ""
      },
      validationSchema: Yup.object({
        name: Yup.string()     
          .required(t('general.message.required')),        
      }),
      onSubmit: (values) => {           
          save('partner/savePartnerContract?partnerId='+props.entityId,values);         
      }
    });

    return (
      <>    
        <div className="modal-container">
                  <Modal
                    show={isOpen}
                    onHide={hideModal}
                    container={this}
                    aria-labelledby="contained-modal-title"
                    centered
                    //size="lg"
                    ref={dialogRef}
                  >
                    <form onSubmit={formik.handleSubmit}>     
                    <Modal.Header closeButton>
                      <Modal.Title id="contained-modal-title">{t('partner.label.contract')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>

                          <div className="row">
                                <div className="col-8 col-sm-8 col-lg-8">
                                    <div className="form-group">
                                      <label>{t('partner.label.contractNameOrNumber')}</label>
                                      <input type="text" className="form-control" placeholder=""  {...formik.getFieldProps('name')} />
                                    </div>
                                    {formik.touched.name && formik.errors.name ? (<div  style={{ color: 'red' }}>{formik.errors.name}</div>) : null} 
                                  </div>       

                                  <div className="col-4 col-sm-4 col-lg-4" >            	       			
	            	       		        	 <div className="form-group">    
	            	       			 		      <label>{t('partner.label.generate')}</label>    	 
											                <Button className="btn btn-default" onClick={getNewContractName}>ABC-123...</Button>
                					          </div>  
                					        </div>      

                          </div>                   

                          <div className="row">

                                <div className="col-3 col-sm-3 col-lg-3">
                                      <div className="form-group">
                                          <label>{t('partner.label.price')}</label>
                                          <NumericInput className="form-control"  precision={2} value={price} step={1} format={numberFormat}  onChange={value => handleNumericChange('price', value)}  />
                                          
                                      </div>
                                </div>

                                <div className="col-3 col-sm-3 col-lg-3">
                                    <div className="form-group">
                                      <label>{t('partner.label.pricePer')}</label>                               
                                      <CustomSelect
                                        className='input'
                                        onChange={value=>formik.setFieldValue('pricePer',value.value)}
                                        value={formik.values.pricePer}
                                        options={pricePerOptions}     
                                      />                                
                                    </div>                             
                                </div>    

                          </div>

                          <div className="row">

                                  <div className="col-3 col-sm-3 col-lg-3">
                                        <div className="form-group">
                                            <label>{t('partner.label.validFrom')}</label>                                                                               
                                            <DatePicker
                                                className='form-control'                                            
                                                selected={validFromLong}
                                                onChange={(value) => setValidFromLong(new Date(value).getTime())}
                                                dateFormat="dd.MM.yyyy"                                                                                                                                
                                            />                                                   						
                                        </div>
                                  </div>        


                                  <div className="col-3 col-sm-3 col-lg-3">
                                        <div className="form-group">
                                            <label>{t('partner.label.validTo')}</label>                                                                               
                                            <DatePicker
                                                className='form-control'                                            
                                                selected={validToLong}
                                                onChange={(value) => setValidToLong(new Date(value).getTime())}
                                                dateFormat="dd.MM.yyyy"                                                                                    
                                            />                                                   						
                                        </div>
                                  </div>   

                          </div>

                          <div className="row">
                                <div className="col-12">
                                  <div className="form-group">
                                    <label>{t('general.label.description')}</label>
                                    <input type="text" className="form-control" placeholder="" {...formik.getFieldProps('description')} />
                                  </div>
                                  {formik.touched.description && formik.errors.description ? (<div  style={{ color: 'red' }}>{formik.errors.description}</div>) : null} 
                                </div>     
                            </div>
                          
                    </Modal.Body>
                    <Modal.Footer>     
                          <Button style={selectedRecord ? {} : { display: 'none' }} className="btn-danger" onClick={deleteRecord}>{t('general.button.delete')}</Button>    
                          <Button style={entityId ? {} : { display: 'none' }} className="btn-primary" type="submit">{t('general.button.save')}</Button>    
                          <Button className="btn-default" onClick={hideModal}>{t('general.button.cancel')}</Button>
                    </Modal.Footer>
                    </form>  
                                        
                  </Modal>                                      
                </div>
               
                <AlertDialog
                open={openAlertDialog}
                message={t('general.message.areYouSure')}
                header={t('general.message.confirmDelete')}
                parentCallback={handleAlertDialogCallback}
                ></AlertDialog> 
      </>
    );
  };

 export default ContractModal;